module.exports = __webpack_public_path__ + "img/armhole yoke.5f05422f.png";